import { variants } from '../constants/variant'

const privacyPolicyMap = {
  default: {
    title: 'Privacy Policy',
    lastUpdated: 'December 10, 2025',
    content: (
      <>
        <p>
          This Privacy Policy describes how we collect, use, and share your personal information when you use our services.
        </p>

        <h3 className="font-bold text-base mt-4">Information We Collect</h3>
        <p>
          We collect information that you provide directly to us, including your name, email address, phone number, 
          and any other information you choose to provide when you fill out our contact form or interact with our services.
        </p>

        <h3 className="font-bold text-base mt-4">How We Use Your Information</h3>
        <p>
          We use the information we collect to:
        </p>
        <ul className="list-disc pl-6">
          <li>Respond to your inquiries and provide customer support</li>
          <li>Send you information about our properties and services</li>
          <li>Improve and personalize your experience</li>
          <li>Comply with legal obligations</li>
        </ul>

        <h3 className="font-bold text-base mt-4">Information Sharing</h3>
        <p>
          We may share your information with service providers who assist us in operating our business, 
          as well as when required by law or to protect our rights.
        </p>

        <h3 className="font-bold text-base mt-4">Your Rights</h3>
        <p>
          You have the right to access, correct, or delete your personal information. 
          Please contact us if you wish to exercise these rights.
        </p>

        <h3 className="font-bold text-base mt-4">Contact Us</h3>
        <p>
          If you have any questions about this Privacy Policy, please contact us through the information provided on our website.
        </p>
      </>
    )
  },
  avalon: {
    title: 'Privacy & Data Usage Notice',
    lastUpdated: 'December 23, 2025',
    content: (
      <>
        <h3 className="font-bold text-base">Your Privacy Matters</h3>
        <p>
          At SparX, we are committed to protecting your privacy through a "data-minimized" approach. 
          We believe your personal information should only be held by the parties you intend to contact.
        </p>

        <h3 className="font-bold text-base mt-4">How We Handle Your Data</h3>
        <p>
          When you submit an inquiry form on this platform, SparX operates as a secure "pass-through" service. 
          We do not collect, store, or retain your personal identifiable information (PII).
        </p>

        <ul className="list-disc pl-6 mt-2 space-y-2">
          <li>
            <strong>Transient Processing:</strong> Your details (including your name, phone number, email address, and comments) 
            are processed momentarily by our backend to generate a notification. This data is transmitted via our secure email 
            delivery partner, Mailjet, directly to the AvalonBay Communities leasing and management team.
          </li>
          <li>
            <strong>No Storage:</strong> Once your message is transmitted, SparX does not keep a record of your personal details in our databases.
          </li>
          <li>
            <strong>Lead Counting:</strong> For performance monitoring purposes, SparX retains only anonymous aggregate counters 
            (e.g., the total number of inquiries sent). This data contains no information that can identify you personally.
          </li>
        </ul>

        <h3 className="font-bold text-base mt-4">AvalonBay Communities</h3>
        <p>
          Since your data is sent directly to AvalonBay representatives, its use and storage are governed by the{' '}
          <a 
            href="https://www.avaloncommunities.com/privacy-policy" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#007bff] hover:underline"
          >
            AvalonBay Privacy Policy
          </a>. 
          We encourage you to review their policy to understand how they manage your housing inquiry.
        </p>
      </>
    )
  }
}

export const privacyPolicyVariantsMap = {
  [variants.df]: privacyPolicyMap.default,
  [variants.ctf]: privacyPolicyMap.default,
  [variants.sw]: privacyPolicyMap.default,
  [variants.ew]: privacyPolicyMap.default,
  [variants.pd]: privacyPolicyMap.default,
  [variants.of]: privacyPolicyMap.default,
  [variants.br]: privacyPolicyMap.default,
  [variants.sf]: privacyPolicyMap.default,
  [variants.ev]: privacyPolicyMap.default,
  [variants.av]: privacyPolicyMap.avalon,
}

export function getPrivacyPolicy(variant) {
  return privacyPolicyVariantsMap[variant] || privacyPolicyMap.default
}

